import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { useTheme } from '@mui/material';
import { formatNumberNoFrac } from '../../common/commonFunctions';
import { AgChartOptions } from 'ag-charts-community';
import { AgCharts } from 'ag-charts-react';

interface LineGraphProps {
  series: any[];
  history: any;
}

export const LineGraph = forwardRef((props: LineGraphProps, ref) => {
  const theme = useTheme();
  const chartRef = useRef<any>(null);

  const [options, setOptions] = useState<AgChartOptions>({
    series: [],
  });

  useImperativeHandle(ref, () => ({
    resize: () => {
      try {
        chartRef?.current?.chart?.performLayout?.();
      } catch (e) {
        console.warn("Resize failed:", e);
      }
    },
  }));

  useEffect(() => {
    const { history, series } = props;

    setOptions({
      data: history,
      theme: theme.palette.mode === 'dark' ? 'ag-default-dark' : 'ag-default',
      legend: {
        position: 'top',
      },
      series: series,
      axes: [
        {
          type: 'time',
          position: 'bottom',
          label: {
            format: '%m-%d-%Y',
          },
        },
        {
          type: 'number',
          position: 'left',
          label: {
            formatter: (params: any) => formatNumberNoFrac?.format(params.value),
          },
        },
      ],
    });
  }, [props]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      try {
        chartRef?.current?.chart?.performLayout?.();
      } catch (e) {
        console.warn("Chart resize failed:", e);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    
    <div style={{ width: '100%', height: '100%' }}>
      <AgCharts ref={chartRef} options={options} style={{ width: '100%', height: '100%' }} />
    </div>
  );
});
